/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../../apiClient'
import type {
  ListSyndigoCategoriesQueryResponse,
  ListSyndigoCategoriesQueryParams,
} from '../../types/ListSyndigoCategories'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { listSyndigoCategories } from '../../clients/listSyndigoCategories'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const listSyndigoCategoriesQueryKey = (
  params?: ListSyndigoCategoriesQueryParams
) =>
  [
    { url: '/api/v1/products/catalog/variants/syndigo/categories/' },
    ...(params ? [params] : []),
  ] as const

export type ListSyndigoCategoriesQueryKey = ReturnType<
  typeof listSyndigoCategoriesQueryKey
>

export function listSyndigoCategoriesQueryOptions(
  params?: ListSyndigoCategoriesQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = listSyndigoCategoriesQueryKey(params)
  return queryOptions<
    ListSyndigoCategoriesQueryResponse,
    ResponseErrorConfig<Error>,
    ListSyndigoCategoriesQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return listSyndigoCategories(params, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @description Get distinct Syndigo categories for the company.
 * GET /catalog/variants/syndigo/categories/
 * Returns:
 * Response with list of distinct categories sorted alphabetically.
 * Each item has 'label' and 'value' keys for frontend compatibility.
 * @summary List distinct Syndigo categories
 * {@link /api/v1/products/catalog/variants/syndigo/categories/}
 */
export function useListSyndigoCategories<
  TData = ListSyndigoCategoriesQueryResponse,
  TQueryData = ListSyndigoCategoriesQueryResponse,
  TQueryKey extends QueryKey = ListSyndigoCategoriesQueryKey,
>(
  params?: ListSyndigoCategoriesQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ListSyndigoCategoriesQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? listSyndigoCategoriesQueryKey(params)

  const query = useQuery(
    {
      ...listSyndigoCategoriesQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
